import React from 'react';
import { motion } from 'framer-motion';

const featuresList = [
  {
    icon: 'fa-rocket',
    title: '系统定义',
    description: '以“刻意练习”为核心的英语“沉浸式”自主学习工具'
  },
  {
    icon: 'fa-shield-alt',
    title: '刻意练习',
    description: '通过测评判断，智能推送学习内容，有针对性的突破和提升'
  },
  {
    icon: 'fa-cogs',
    title: '沉浸式学习',
    description: '通过算法，让学生简单、轻松的动作沉浸在学习过程当中'
  },
  {
    icon: 'fa-chart-line',
    title: '自主学习',
    description: '摆脱老师讲、学生听的传统学习模式'
  },
  {
    icon: 'fa-mobile-alt',
    title: '系统定位',
    description: '助力学生智能提分的英语自主学习工具'
  },
  {
    icon: 'fa-cloud',
    title: '系统优势',
    description: '不刻意背单词，不培训、补齐、刷题，通过AI算法轻松提分'
  }
];

const Features = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section id="features" className="py-20 dark:bg-gray-900 pt-40">
      <div className="container">
        <motion.div
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-white mb-4">英语提分系统</h2>
          <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 max-w-2xl mx-auto">探索我们系统的强大能力</p>
        </motion.div>

        <motion.div
          className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {featuresList.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 dark:border-gray-700"
              variants={itemVariants}
            >
              <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-6">
                <i className={`fas ${feature.icon} text-secondary text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-secondary">{feature.title}</h3>
              <p className="text-gray-600 dark:text-gray-400">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
